<template>
    <span @click="gotoAlarm" class="antd-pro-components-global-header-index-action antd-pro-components-notice-icon-index-noticeButton ant-dropdown-trigger" style="margin-right: 10px;">
        <audio ref="audio" src="/mp3/alarm.mp3" control></audio>
        <a-badge :numberStyle="sty" :count="alarmNumer">
           <!-- <a-icon type="bell" class="bell" /> -->
           <i :class="alarmNumer > 0 ? 'icon-lg bell-red' : 'icon-lg bell-primary'">
             <zx-icon type="icon-gaojing1"></zx-icon>
           </i>
        </a-badge>
    </span>
</template>

<script>
    // import Vue from 'vue'
    import config from '@/config'
    import bus from '../../bus/bus'
    import {mapGetters, mapState, mapMutations} from 'vuex'
    import {computedAlarmIcon} from '../../utils/homeFn'
    export default {
        name: 'ZAlarm',
        data() {
            return {
                alarmNumer: 0,
                refreshInterval: 120,
                timer: null,
                sty: {
                  // fontSize: '5px',
                  padding: '0 3px'
                },
                alarms: ''
            }
        },
        computed: {
          ...mapGetters(['token']),
          ...mapState(['alarmNoticeType', 'alarmConfig'])
        },
        beforeDestroy () {
            // clearInterval(this.timer);
            // this.timer = null;
          this.clearAlarmInterval()
        },
        watch: {
          alarmNumer (newV) {
            // console.log(newV)
            if (newV < 0) {
              this.alarmNumer = 0
            }
          }
        },
        methods: {
          ...mapMutations(['initAlarmConfig', 'setAlarmConfig']),
            gotoAlarm () {
                // console.log(this.$route)
                if (!(this.$route.path === '/alarm/list')) {
                    // this.$router.push('/alarm/list')
                    bus.$emit('routeChange', {
                        route: '/alarm/list',
                        key: '17'
                    })
                    // Vue.ls.set('activeMenu', item.key)
                }
            },
            intervalAlarmMp3Play () {
              this.alarmPlayTimer = setInterval(() => {
                this.$refs['audio'].play()
              }, 1000)
            },
            clearAlarmInterval () {
              if (this.alarmPlayTimer) {
                clearInterval(this.alarmPlayTimer)
                this.alarmPlayTimer = null
              }
            },
            // 计算该如何响铃
            computedAlarmRing (alarmConfig, alarmNums) {
              // 遍历一直响的告警设置，得到找出一直响的告警id集合，与现有告警的id比较，若有（数量之和大于1）则让告警一直响
              let alarms = Object.keys(alarmNums).map((key) => {
                let item = {
                  code: key,
                  num: alarmNums[key],
                  ringType: alarmConfig.find((config) => config.alarmType.code == key).ringType
                }
                return item
              })
              // console.log(alarms)
              this.alarms = alarms
              // 当arr的长度为1的时候，会返回当前元素本身
              let alwaysNums = alarms.filter((alarm) => alarm.ringType == 3).reduce((pre, cur) => pre + cur.num, 0)
              // console.log(alwaysNums)
              let onceNums = alarms.filter((alarm) => alarm.ringType == 2).reduce((pre, cur) => pre + cur.num, 0)
              // console.log(alwaysNums)
              // console.log(onceNums)
              if (alwaysNums > 0 && !this.alarmPlayTimer) {
                this.intervalAlarmMp3Play()
              } else {
                if (onceNums > 0) {
                  this.$refs['audio'].play()
                }
              }
            },
            refreshAlarm(isInit) {
              this.$http.get(config.api.alarm_number_url + isInit ).then((response) => {
                  if(response.code == 0){
                      // console.log(response)
                      if (isInit === '/true') {
                        // 首次请求
                        const {alarmConfig, alarmNums} = response.result
                        this.alarmNumer = Object.values(alarmNums).reduce((pre, cur) => pre + cur, 0)
                        this.initAlarmConfig(alarmConfig)
                        this.computedAlarmRing(alarmConfig, alarmNums)
                      } else {
                        // 轮询的情况
                        const {alarmNums} = response.result
                        this.alarmNumer = Object.values(alarmNums).reduce((pre, cur) => pre + cur, 0)
                      }
                  }
                })
            },
            isClearRing (alarms, disposedAlarms) {
              Object.keys(disposedAlarms).forEach((key) => {
                let index = alarms.findIndex((alarm) => alarm.code == key)
                if (index) {
                  alarms[index].num = alarms[index].num - disposedAlarms[key]
                  // console.log(alarms[index])
                }
              })
              // console.log(alarms)
              this.alarms = alarms
            },
            // 触发告警后，用户点击详情后跳转到首页或告警页面
            navgateTo (id, key) {
              if (id) {
                return () => {
                  bus.$emit('routeChange', {
                    route: '/home',
                    key: '1',
                    query: {
                      id
                    }
                  })
                  this.$notification.close(key)
                }
                // ...
              } else {
                return () => {
                  // this.$router.push('/alarm/list')
                  bus.$emit('routeChange', {
                    route: '/alarm/list',
                    key: '17'
                  })
                  this.$notification.close(key)
                }
              }
              // 关闭弹出框
            },
        },
        mounted() {
          this.refreshAlarm('/true');
          this.timer = setInterval(this.refreshAlarm('/false'), this.refreshInterval*1000)
          this.$socket.emit('init', this.token)
        },
        sockets: {
          connect () {
            console.log('socket 已连接')
          },
          reconnect () {
            console.log('socket 重连')
            this.$socket.emit('init', this.token)
          },
          disconnect () {
            console.log('socket 断开连接')
          },
          alarm (ev) {
            console.log('接收到socket 推送的告警信息')
            console.log(ev)
            // 判断如何响铃
            const currentAlarmConfig = this.alarmConfig.find((config) => config.alarmType.code == ev.alarmCode)
            // console.log(currentAlarmConfig)
            if (currentAlarmConfig.ringType == '3' && !this.alarmPlayTimer) {
              this.intervalAlarmMp3Play()
            } else if (currentAlarmConfig.ringType == '2') {
              this.$refs['audio'].play()
            }
            // 将告警数量相加
            this.alarmNumer += ev.delta
            const key = this.$moment().unix()
            // 存在message说明是配置了前端推送的告警类型 (这种判断方式并不准确(应该按alarmCode去判断是否配置了前端推送)，但相对安全，因为显示的内容都在message里面)
            if (ev.message) {
              this.$notification.error({
                key,
                // message: ev.message.entityName + ' -- ' + ev.message.alarmName,
                message: ev.message.entityName + ' -- ' +  this.$t(`alarm.${ev.message.alarmName}`),
                description: (h) => {
                  return [
                    h('div', {}, this.$moment(ev.message.timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')),
                    h('div', {
                      props: {
                        'v-if': ev.message.position
                      }
                    }, ev.message.position)
                  ]
                },
                duration: null,
                icon: (h) => {
                  return h('i', {
                    style: {
                      color: 'red'
                    }
                  },
                  [
                    h('zx-icon', {
                      props: {
                        type: computedAlarmIcon(ev.alarmCode)
                      }
                    })
                  ])
                },
                btn: (h) => {
                  if (ev.message.entityId) {
                    return h('a-button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                      },
                      on: {
                        click: this.navgateTo(ev.message.entityId, key)
                      }
                    }, this.$t(`global.detail`))
                  }
                }
              })
            }
          },
          alarmConfigUpdate (ev) {
            console.log('接收到socket推送 改变了告警配置!')
            console.log(ev)
            this.setAlarmConfig(ev)
          },
          alarmDispose (ev) {
            console.log('接收到socket推送 处理了告警！')
            console.log(ev)
            let disposeNum = Object.values(ev).reduce((pre, cur) => pre + cur)
            this.alarmNumer -= disposeNum
            // console.log(this.alarmNumer)
            // console.log(this.alarms)
            this.isClearRing(this.alarms, ev)
            let alwaysNums = this.alarms.filter((alarm) => alarm.ringType == 3).reduce((pre, cur) => pre + cur.num, 0)
            // let onceNums = this.alarms.filter((alarm) => alarm.ringType == 2).reduce((pre, cur) => pre + cur.num, 0)
            // 清除一直响铃
            if (alwaysNums == 0) {
              this.alarmPlayTimer && clearInterval(this.alarmPlayTimer)
            }
          }
        }
    }
</script>
<style lang="less" scoped>
.bell-red {
    font-size: 22px;
    vertical-align: middle;
    color: #ad0c0c;
}
.bell-primary {
  font-size: 22px;
  vertical-align: middle;
  color: #e7e7e7;
}
</style>
